export const eventsTranslations = {
  en: {
    events: "Events",
    event_details: "Event Details",
    all_events: "All Events",
    my_events: "My Events",
    events_tabs: "Events Tabs",
    create_new_event: "Create New Event",
    share_event: "Share Event",
    invite_fighters: "Invite fighters",
    invite_fighters_help: "Select from Hoowlr fighters",
    invite_by_email: "Invite by email",
    invite_by_email_help: "Send via email address",
    select_hoowlr_fighters: "Select Hoowlr fighters",
    select_hoowlr_fighters_help: "Choose people from the list.",
    selected: "selected",
    selected_fighter: "Selected fighter",
    remove_selected_fighter: "Remove selected fighter",
    fighters_found: "{{count}} fighters",
    page: "Page",
    no_fighters_found: "No fighters found",
    try_different_fighter_search: "Try a different name.",
    fighters_not_available: "No fighters are currently available.",
    search_fighters_to_share: "Search fighters by name",
    hoowlr_fighter: "Hoowlr fighter",
    previous: "Previous",
    next: "Next",
    share_by_email: "Share by email",
    share_event_email_single_help: "Add one email address at a time. Each recipient will appear separately below.",
    added: "added",
    enter_email_address: "Enter one email address",
    add_email: "Add email",
    share_event_email_enter_hint: "Press Enter or click Add email. Comma-separated addresses are not required.",
    email_recipient: "Email recipient",
    remove_email_recipient: "Remove email recipient",
    no_email_recipients_added: "No email recipients added yet.",
    message: "Message",
    share_event_message_placeholder: "Add a message (optional)",
    attachments: "Attachments",
    add_file: "Add file",
    no_attachments_added: "No files attached yet.",
    remove_attachment: "Remove attachment",
    attachment_too_large: "{{fileName}} is too large. Max size is 25MB.",
    attachment_upload_failed: "Failed to upload attachment(s)",
    event_shared_successfully: "Event shared successfully",
    failed_to_share_event: "Failed to share event",
    share_event_invalid_email: "Invalid email: {{email}}",
    share_event_email_already_added: "This email address has already been added.",
    share_event_recipient_required: "Select at least one Hoowlr fighter or add an email address.",
    uploading: "Uploading...",
    share: "Share",

    view_share_history: "View Share History",
    share_history: "Share History",
    share_history_loading: "Loading share history...",
    share_history_empty: "No share history yet",
    share_history_empty_help: "Shares for this event will appear here.",
    failed_to_load_share_history: "Failed to load share history",
    recipients: "Recipients",
    download: "Download",

    search_placeholder: "Search by event name, venue, location, or organizer...",
    select_status: "Select Status",
    select_location: "Select Location",
    reset_filters: "Reset Filters",
    no_events_found: "No events found",
    retry: "Retry",
    loading: "Loading...",
    loading_events: "Loading events...",
    get_started_events: "Get started by creating your first combat sports event!",
    try_changing_filters: "Try clearing or changing your search filters.",

    fight_card_matchups: "Fight Card & Matchups",
    manage_bouts: "Manage bouts and opportunities for this event",
    add_matchup: "Add Matchup",
    download_matchup_list_pdf_tooltip: "Download this event's full matchup list as a PDF",
    no_matchups: "No matchups yet",
    no_matchups_found: "No matchups yet. Add the first bout.",
    add_first_bout: "Start building your fight card by adding the first bout.",
    cancelled_event_fight_card_read_only: "This event is cancelled, so its fight card is read-only.",

    red_corner: "Red Corner",
    blue_corner: "Blue Corner",
    red_corner_fighter: "Red Corner Fighter",
    blue_corner_fighter: "Blue Corner Fighter",
    title_fight: "Title Fight",
    create_opportunity: "Create Opportunity",
    create_deal: "Create Deal",
    view_deal: "View Deal",
    view_opportunity: "View Opportunity",
    opportunity_created: "Opportunity Created",

    opportunity_visibility: "Opportunity Visibility",
    opportunity_description: "Choose how you want to make this bout available",
    marketplace: "Marketplace",
    marketplace_description: "Make this opportunity visible to fighters and managers in the marketplace.",
    direct_to_fighter: "Direct to Fighter",
    direct_to_fighter_description: "Send this opportunity directly to the red or blue corner fighter or manager.",
    selected_visibility: "Selected visibility",

    bout: "Bout",
    bouts: "Bouts",
    bout_number: "Bout {{number}}",
    matchup: "Matchup",
    status: "Status",
    tbd: "TBD",
    to_be_determined: "To Be Determined",
    vs: "VS",
    not_available: "N/A",
    not_available_short: "--",

    no_description_available: "No description available",
    organizer: "Organizer",
    organizer_label: "Organizer",
    start: "Start",
    end: "End",
    created: "Created",
    created_at: "Created At",
    modified_date: "Modified {{date}}",
    location_tbd: "Location TBD",
    change_status: "Change Status",

    event_name: "Event Name",
    event_name_placeholder: "e.g. Fight Night",
    description: "Description",
    description_placeholder: "Event background, special rules, or main attraction notes...",
    venue: "Venue",
    venue_placeholder: "e.g. Salem Indoor Stadium",
    country: "Country",
    city: "City",
    select_country_first: "Select country first",
    loading_cities: "Loading cities...",
    search_city: "Search city...",
    clear_city: "Clear city",
    no_cities_found: "No cities found",
    location: "Location",
    location_placeholder: "e.g. Salem, Tamil Nadu",

    start_date: "Start Date",
    end_date: "End Date",
    start_date_time: "Start Date & Time",
    end_date_time: "End Date & Time",
    event: "Event",
    select_combat_sport: "Select combat sport",
    select_weight_class: "Select weight class",
    event_name_required: "Event name is required",
    venue_required: "Venue is required",
    country_required: "Country is required",
    city_required: "City is required",
    location_required: "Location is required",
    start_date_required: "Start date is required",
    start_date_past: "Start date cannot be in the past",
    start_date_time_required: "Start date and time is required",
    start_date_time_past: "Start date and time cannot be in the past",
    end_date_time_required: "End date and time is required",
    end_date_time_past: "End date and time cannot be in the past",
    end_date_after_start_date: "Event end date and time must be after or equal to start date and time",

    draft: "Draft",
    published: "Published",
    upcoming: "Upcoming",
    live: "Live",
    completed: "Completed",
    cancelled: "Cancelled",

    event_status: {
    DRAFT: "Draft",
    PUBLISHED: "Published",
    UPCOMING: "Upcoming",
    LIVE: "Live",
    COMPLETED: "Completed",
    CANCELLED: "Cancelled",
  },

    matchup_status: {
      DRAFT: "Draft",
      OPPORTUNITY_POSTED: "Opportunity Posted",
      RED_ACCEPTED: "Red Accepted",
      BLUE_ACCEPTED: "Blue Accepted",
      BOTH_ACCEPTED: "Both Accepted",
      CONFIRMED: "Confirmed",
      CANCELLED: "Cancelled",
    },

    profile_type: {
      FIGHTER: "Fighter",
      MANAGER: "Manager",
      ORGANIZATION: "Organization",
    },

    opportunity_posted: "Opportunity Posted",
    red_accepted: "Red Accepted",
    blue_accepted: "Blue Accepted",
    both_accepted: "Both Accepted",
    confirmed: "Confirmed",
    mma: "MMA",

    cancel: "Cancel",
    save: "Save",
    edit: "Edit",
    delete: "Delete",
    confirm: "Confirm",
    update: "Update",
    clear: "Clear",

    edit_event: "Edit Event",
    create_event: "Create Event",
    save_changes: "Save Changes",
    edit_event_subtitle: "Update combat sports event details",
    create_event_subtitle: "Schedule and announce a new combat sports event",

    confirm_delete_title: "Confirm Delete",
    confirm_delete_message: "Are you sure you want to delete this event? This action cannot be undone.",
    confirm_update_title: "Confirm Update",
    confirm_update_message: "Are you sure you want to update this event?",
    confirm_status_change_title: "Confirm Status Change",
    confirm_status_change_message: "Are you sure you want to change the event status to {{status}}?",

    event_deleted_successfully: "Event deleted successfully",
    event_updated_successfully: "Event updated successfully",
    event_created_successfully: "Event created successfully",
    status_updated_successfully: "Status updated successfully",
    status_update_failed: "Failed to update status. Please try again.",
    failed_to_delete_event: "Failed to delete event",
    failed_to_update_event: "Failed to update event",
    failed_to_load_event_details: "Failed to load event details",
    failed_to_save_event: "Failed to save event. Please try again.",
    event_not_found: "Event not found or currently unavailable.",
    event_load_failed: "Could not load event details. Please try again.",
    loading_event_details: "Loading event details...",
    failed_to_load_event: "Failed to load Event",
    back_to_events: "Back to Events",

    add_matchup_subtitle: "Configure championship status and required fighters",
    bout_order: "Bout Order",
    championship_title_fight: "Championship / Title Fight",
    select_red_corner_fighter: "Select Red Corner Fighter",
    select_blue_corner_fighter: "Select Blue Corner Fighter",
    red_corner_fighter_required: "Red corner fighter is required.",
    blue_corner_fighter_required: "Blue corner fighter is required.",
    same_fighter_error: "Red and Blue corner fighters cannot be the same person",
    matchup_created_successfully: "Matchup added successfully",
    failed_to_create_matchup: "Failed to add matchup",
    edit_matchup: "Edit Matchup",
    edit_matchup_subtitle: "Update championship status or fighters",
    matchup_updated_successfully: "Matchup updated successfully",
    failed_to_update_matchup: "Failed to update matchup",
    matchup_deleted_successfully: "Matchup deleted successfully",
    failed_to_delete_matchup: "Failed to delete matchup",
    confirm_delete_matchup_title: "Delete Bout",
    confirm_delete_matchup_message: "Are you sure you want to delete this matchup? This action cannot be undone.",
    delete_matchup: "Delete Matchup",
    loading_fighters: "Loading fighters...",
    no_fighter_selected: "None / TBD (To be determined)",
    failed_to_load_fighters: "Failed to load fighters",
    fighter_has_deal_locked: "This fighter has a deal and cannot be changed.",
    fighter_not_selected: "Fighter not selected",
    fighter_number: "Fighter #{{id}}",
    no_nickname: "No nickname",
    nationality: "Nationality",
    weight_class: "Weight Class",
    discipline: "Discipline",
    stance: "Stance",
    title_holder: "Title Holder",
    select_fighter_above: "Select a fighter above",
    failed_to_load_templates: "Failed to load templates",
    choose_template: "Choose a Template",
    select_template_to_preview: "Select a template to preview",
    template_available: "{{count}} template available",
    templates_available: "{{count}} templates available",
    no_templates_available: "No templates available",
    steps_count: "{{count}} steps",
    add_account: "Add Account",
account_verification_pending: "Account Verification Pending",
  },

  de: {
    events: "Veranstaltungen",
    event_details: "Veranstaltungsdetails",
    all_events: "Alle Veranstaltungen",
    my_events: "Meine Veranstaltungen",
    events_tabs: "Veranstaltungs-Tabs",
    create_new_event: "Neue Veranstaltung erstellen",
    download_matchup_list_pdf_tooltip: "Laden Sie die vollständige Matchup-Liste für dieses Event als PDF herunter",

    search_placeholder: "Nach Veranstaltungsname, Ort, Standort oder Organisator suchen...",
    select_status: "Status auswählen",
    select_location: "Standort auswählen",
    reset_filters: "Filter zurücksetzen",
    no_events_found: "Keine Veranstaltungen gefunden",
    retry: "Erneut versuchen",
    loading: "Wird geladen...",
    loading_events: "Veranstaltungen werden geladen...",
    get_started_events: "Erstellen Sie Ihre erste Kampfsportveranstaltung!",
    try_changing_filters: "Versuchen Sie, die Filter zu löschen oder zu ändern.",

    fight_card_matchups: "Fight Card & Paarungen",
    manage_bouts: "Verwalten Sie Kämpfe und Möglichkeiten für diese Veranstaltung",
    add_matchup: "Paarung hinzufügen",
    no_matchups: "Noch keine Paarungen",
    no_matchups_found: "Noch keine Paarungen. Fügen Sie den ersten Kampf hinzu.",
    add_first_bout: "Beginnen Sie Ihre Fight Card mit dem ersten Kampf.",
    cancelled_event_fight_card_read_only: "Diese Veranstaltung wurde abgesagt, daher ist die Fight Card schreibgeschützt.",

    red_corner: "Rote Ecke",
    blue_corner: "Blaue Ecke",
    red_corner_fighter: "Kämpfer der roten Ecke",
    blue_corner_fighter: "Kämpfer der blauen Ecke",
    title_fight: "Titelkampf",
    create_opportunity: "Opportunity erstellen",
    create_deal: "Deal erstellen",
    view_deal: "Deal ansehen",
    view_opportunity: "Opportunity ansehen",
    opportunity_created: "Opportunity erstellt",

    opportunity_visibility: "Sichtbarkeit der Opportunity",
    opportunity_description: "Wählen Sie aus, wie dieser Kampf verfügbar gemacht werden soll",
    marketplace: "Marktplatz",
    marketplace_description: "Machen Sie diese Opportunity für Kämpfer und Manager auf dem Marktplatz sichtbar.",
    direct_to_fighter: "Direkt an Kämpfer",
    direct_to_fighter_description: "Senden Sie diese Opportunity direkt an den Kämpfer oder Manager der roten oder blauen Ecke.",
    selected_visibility: "Ausgewählte Sichtbarkeit",

    bout: "Kampf",
    bouts: "Kämpfe",
    bout_number: "Kampf {{number}}",
    matchup: "Paarung",
    status: "Status",
    tbd: "Noch offen",
    to_be_determined: "Noch festzulegen",
    vs: "VS",
    not_available: "Nicht verfügbar",
    not_available_short: "--",

    no_description_available: "Keine Beschreibung verfügbar",
    organizer: "Organisator",
    organizer_label: "Organisator",
    start: "Start",
    end: "Ende",
    created: "Erstellt",
    created_at: "Erstellt am",
    modified_date: "Geändert {{date}}",
    location_tbd: "Standort offen",
    change_status: "Status ändern",

    event_name: "Veranstaltungsname",
    event_name_placeholder: "z. B. Fight Night",
    description: "Beschreibung",
    description_placeholder: "Hintergrund, besondere Regeln oder Hinweise zur Hauptattraktion...",
    venue: "Veranstaltungsort",
    venue_placeholder: "z. B. Salem Indoor Stadium",
    country: "Land",
    city: "Stadt",
    select_country_first: "Zuerst Land auswählen",
    loading_cities: "Städte werden geladen...",
    search_city: "Stadt suchen...",
    clear_city: "Stadt löschen",
    no_cities_found: "Keine Städte gefunden",
    location: "Standort",
    location_placeholder: "z. B. Salem, Tamil Nadu",

    start_date: "Startdatum",
    end_date: "Enddatum",
    start_date_time: "Startdatum und -zeit",
    end_date_time: "Enddatum und -zeit",
    event: "Veranstaltung",
    select_combat_sport: "Kampfsport auswählen",
    select_weight_class: "Gewichtsklasse auswählen",

    event_name_required: "Veranstaltungsname ist erforderlich",
    venue_required: "Veranstaltungsort ist erforderlich",
    country_required: "Land ist erforderlich",
    city_required: "Stadt ist erforderlich",
    location_required: "Standort ist erforderlich",
    start_date_required: "Startdatum ist erforderlich",
    start_date_past: "Startdatum darf nicht in der Vergangenheit liegen",
    start_date_time_required: "Startdatum und -zeit sind erforderlich",
    start_date_time_past: "Startdatum und -zeit dürfen nicht in der Vergangenheit liegen",
    end_date_time_required: "Enddatum und -zeit sind erforderlich",
    end_date_time_past: "Enddatum und -zeit dürfen nicht in der Vergangenheit liegen",
    end_date_after_start_date: "Enddatum und -zeit müssen nach oder gleich Startdatum und -zeit sein",

    draft: "Entwurf",
    published: "Veröffentlicht",
    upcoming: "Bevorstehend",
    live: "Live",
    completed: "Abgeschlossen",
    cancelled: "Abgesagt",

    event_status: {
    DRAFT: "Entwurf",
    PUBLISHED: "Veröffentlicht",
    UPCOMING: "Bevorstehend",
    LIVE: "Live",
    COMPLETED: "Abgeschlossen",
    CANCELLED: "Abgesagt",
  },

    matchup_status: {
      DRAFT: "Entwurf",
      OPPORTUNITY_POSTED: "Opportunity veröffentlicht",
      RED_ACCEPTED: "Rote Ecke akzeptiert",
      BLUE_ACCEPTED: "Blaue Ecke akzeptiert",
      BOTH_ACCEPTED: "Beide akzeptiert",
      CONFIRMED: "Bestätigt",
      CANCELLED: "Abgesagt",
    },

    profile_type: {
      FIGHTER: "Kämpfer",
      MANAGER: "Manager",
      ORGANIZATION: "Organisation",
    },

    opportunity_posted: "Opportunity veröffentlicht",
    red_accepted: "Rote Ecke akzeptiert",
    blue_accepted: "Blaue Ecke akzeptiert",
    both_accepted: "Beide akzeptiert",
    confirmed: "Bestätigt",
    mma: "MMA",

    cancel: "Abbrechen",
    save: "Speichern",
    edit: "Bearbeiten",
    delete: "Löschen",
    confirm: "Bestätigen",
    update: "Aktualisieren",
    clear: "Löschen",

    edit_event: "Veranstaltung bearbeiten",
    create_event: "Veranstaltung erstellen",
    save_changes: "Änderungen speichern",
    edit_event_subtitle: "Details der Kampfsportveranstaltung aktualisieren",
    create_event_subtitle: "Neue Kampfsportveranstaltung planen und ankündigen",

    confirm_delete_title: "Löschen bestätigen",
    confirm_delete_message: "Sind Sie sicher, dass Sie diese Veranstaltung löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
    confirm_update_title: "Aktualisierung bestätigen",
    confirm_update_message: "Sind Sie sicher, dass Sie diese Veranstaltung aktualisieren möchten?",
    confirm_status_change_title: "Statusänderung bestätigen",
    confirm_status_change_message: "Sind Sie sicher, dass Sie den Veranstaltungsstatus auf {{status}} ändern möchten?",

    event_deleted_successfully: "Veranstaltung erfolgreich gelöscht",
    event_updated_successfully: "Veranstaltung erfolgreich aktualisiert",
    event_created_successfully: "Veranstaltung erfolgreich erstellt",
    status_updated_successfully: "Status erfolgreich aktualisiert",
    status_update_failed: "Status konnte nicht aktualisiert werden. Bitte versuchen Sie es erneut.",
    failed_to_delete_event: "Veranstaltung konnte nicht gelöscht werden",
    failed_to_update_event: "Veranstaltung konnte nicht aktualisiert werden",
    failed_to_load_event_details: "Veranstaltungsdetails konnten nicht geladen werden",
    failed_to_save_event: "Veranstaltung konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.",
    event_not_found: "Veranstaltung nicht gefunden oder derzeit nicht verfügbar.",
    event_load_failed: "Veranstaltungsdetails konnten nicht geladen werden. Bitte versuchen Sie es erneut.",
    loading_event_details: "Veranstaltungsdetails werden geladen...",
    failed_to_load_event: "Veranstaltung konnte nicht geladen werden",
    back_to_events: "Zurück zu Veranstaltungen",

    add_matchup_subtitle: "Meisterschaftsstatus und erforderliche Kämpfer konfigurieren",
    bout_order: "Kampfreihenfolge",
    championship_title_fight: "Meisterschaft / Titelkampf",
    select_red_corner_fighter: "Kämpfer der roten Ecke auswählen",
    select_blue_corner_fighter: "Kämpfer der blauen Ecke auswählen",
    red_corner_fighter_required: "Kämpfer der roten Ecke ist erforderlich.",
    blue_corner_fighter_required: "Kämpfer der blauen Ecke ist erforderlich.",
    same_fighter_error: "Rote und blaue Ecke können nicht dieselbe Person sein",
    matchup_created_successfully: "Paarung erfolgreich hinzugefügt",
    failed_to_create_matchup: "Paarung konnte nicht hinzugefügt werden",
    edit_matchup: "Paarung bearbeiten",
    edit_matchup_subtitle: "Meisterschaftsstatus oder Kämpfer aktualisieren",
    matchup_updated_successfully: "Paarung erfolgreich aktualisiert",
    failed_to_update_matchup: "Paarung konnte nicht aktualisiert werden",
    matchup_deleted_successfully: "Paarung erfolgreich gelöscht",
    failed_to_delete_matchup: "Paarung konnte nicht gelöscht werden",
    confirm_delete_matchup_title: "Kampf löschen",
    confirm_delete_matchup_message: "Sind Sie sicher, dass Sie diese Paarung löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
    delete_matchup: "Paarung löschen",
    loading_fighters: "Kämpfer werden geladen...",
    no_fighter_selected: "Keiner / offen",
    failed_to_load_fighters: "Kämpfer konnten nicht geladen werden",
    fighter_has_deal_locked: "Dieser Kämpfer hat einen Deal und kann nicht geändert werden.",
    fighter_not_selected: "Kein Kämpfer ausgewählt",
    fighter_number: "Kämpfer #{{id}}",
    no_nickname: "Kein Spitzname",
    nationality: "Nationalität",
    weight_class: "Gewichtsklasse",
    discipline: "Disziplin",
    stance: "Stance",
    title_holder: "Titelträger",
    select_fighter_above: "Wählen Sie oben einen Kämpfer aus",
    failed_to_load_templates: "Vorlagen konnten nicht geladen werden",
    choose_template: "Vorlage auswählen",
    select_template_to_preview: "Wählen Sie eine Vorlage zur Vorschau aus",
    template_available: "{{count}} Vorlage verfügbar",
    templates_available: "{{count}} Vorlagen verfügbar",
    no_templates_available: "Keine Vorlagen verfügbar",
    steps_count: "{{count}} Schritte",
    add_account: "Konto hinzufügen",
account_verification_pending: "Kontoüberprüfung ausstehend",
share_event: "Event teilen",
invite_fighters: "Kämpfer einladen",
invite_fighters_help: "Aus Hoowlr-Kämpfern auswählen",
invite_by_email: "Per E-Mail einladen",
invite_by_email_help: "Über E-Mail-Adresse senden",
select_hoowlr_fighters: "Hoowlr-Kämpfer auswählen",
select_hoowlr_fighters_help: "Wählen Sie Personen aus der Liste aus.",
selected: "ausgewählt",
selected_fighter: "Ausgewählter Kämpfer",
remove_selected_fighter: "Ausgewählten Kämpfer entfernen",
fighters_found: "{{count}} Kämpfer",
page: "Seite",
no_fighters_found: "Keine Kämpfer gefunden",
try_different_fighter_search: "Versuchen Sie einen anderen Namen.",
fighters_not_available: "Derzeit sind keine Kämpfer verfügbar.",
search_fighters_to_share: "Kämpfer nach Namen suchen",
hoowlr_fighter: "Hoowlr-Kämpfer",
previous: "Zurück",
next: "Weiter",
share_by_email: "Per E-Mail teilen",
share_event_email_single_help: "Fügen Sie jeweils eine E-Mail-Adresse hinzu. Jeder Empfänger wird unten separat angezeigt.",
added: "hinzugefügt",
enter_email_address: "Eine E-Mail-Adresse eingeben",
add_email: "E-Mail hinzufügen",
share_event_email_enter_hint: "Drücken Sie Enter oder klicken Sie auf E-Mail hinzufügen. Durch Kommas getrennte Adressen sind nicht erforderlich.",
email_recipient: "E-Mail-Empfänger",
remove_email_recipient: "E-Mail-Empfänger entfernen",
no_email_recipients_added: "Noch keine E-Mail-Empfänger hinzugefügt.",
message: "Nachricht",
share_event_message_placeholder: "Nachricht hinzufügen (optional)",
attachments: "Anhänge",
add_file: "Datei hinzufügen",
no_attachments_added: "Noch keine Dateien angehängt.",
remove_attachment: "Anhang entfernen",
attachment_too_large: "{{fileName}} ist zu groß. Maximale Größe: 25 MB.",
attachment_upload_failed: "Anhänge konnten nicht hochgeladen werden",
event_shared_successfully: "Veranstaltung erfolgreich geteilt",
failed_to_share_event: "Veranstaltung konnte nicht geteilt werden",
share_event_invalid_email: "Ungültige E-Mail: {{email}}",
share_event_email_already_added: "Diese E-Mail-Adresse wurde bereits hinzugefügt.",
share_event_recipient_required: "Wählen Sie mindestens einen Hoowlr-Kämpfer aus oder fügen Sie eine E-Mail-Adresse hinzu.",
uploading: "Wird hochgeladen...",
share: "Teilen",

    view_share_history: "Freigabeverlauf anzeigen",
    share_history: "Freigabeverlauf",
    share_history_loading: "Freigabeverlauf wird geladen...",
    share_history_empty: "Noch kein Freigabeverlauf",
    share_history_empty_help: "Freigaben für diese Veranstaltung werden hier angezeigt.",
    failed_to_load_share_history: "Freigabeverlauf konnte nicht geladen werden",
    recipients: "Empfänger",
    download: "Herunterladen",
  },

  hr: {
    events: "Događaji",
    event_details: "Detalji događaja",
    all_events: "Svi događaji",
    my_events: "Moji događaji",
    events_tabs: "Kartice događaja",
    create_new_event: "Stvori novi događaj",

    search_placeholder: "Pretraži po nazivu događaja, mjestu, lokaciji ili organizatoru...",
    select_status: "Odaberi status",
    select_location: "Odaberi lokaciju",
    reset_filters: "Poništi filtre",
    no_events_found: "Nema pronađenih događaja",
    retry: "Pokušaj ponovno",
    loading: "Učitavanje...",
    loading_events: "Učitavanje događaja...",
    get_started_events: "Započni stvaranjem prvog borilačkog događaja!",
    try_changing_filters: "Pokušaj očistiti ili promijeniti filtre pretraživanja.",

    fight_card_matchups: "Fight Card i parovi",
    manage_bouts: "Upravljaj borbama i prilikama za ovaj događaj",
    add_matchup: "Dodaj par",
    no_matchups: "Još nema parova",
    no_matchups_found: "Još nema parova. Dodaj prvu borbu.",
    add_first_bout: "Započni fight card dodavanjem prve borbe.",
    cancelled_event_fight_card_read_only: "Ovaj događaj je otkazan, pa je fight card samo za pregled.",

    red_corner: "Crveni kut",
    blue_corner: "Plavi kut",
    red_corner_fighter: "Borac crvenog kuta",
    blue_corner_fighter: "Borac plavog kuta",
    title_fight: "Borba za naslov",
    create_opportunity: "Stvori priliku",
    create_deal: "Stvori dogovor",
    view_deal: "Pogledaj dogovor",
    view_opportunity: "Pogledaj priliku",
    opportunity_created: "Prilika stvorena",

    opportunity_visibility: "Vidljivost prilike",
    opportunity_description: "Odaberi kako želiš učiniti ovu borbu dostupnom",
    marketplace: "Tržnica",
    marketplace_description: "Učini ovu priliku vidljivom borcima i menadžerima na tržnici.",
    direct_to_fighter: "Izravno borcu",
    direct_to_fighter_description: "Pošalji ovu priliku izravno borcu ili menadžeru iz crvenog ili plavog kuta.",
    selected_visibility: "Odabrana vidljivost",

    bout: "Borba",
    bouts: "Borbe",
    bout_number: "Borba {{number}}",
    matchup: "Par",
    status: "Status",
    tbd: "Nije određeno",
    to_be_determined: "Tek treba odrediti",
    vs: "VS",
    not_available: "Nije dostupno",
    not_available_short: "--",

    no_description_available: "Opis nije dostupan",
    organizer: "Organizator",
    organizer_label: "Organizator",
    start: "Početak",
    end: "Kraj",
    created: "Stvoreno",
    created_at: "Stvoreno",
    modified_date: "Izmijenjeno {{date}}",
    location_tbd: "Lokacija nije određena",
    change_status: "Promijeni status",

    event_name: "Naziv događaja",
    event_name_placeholder: "npr. Fight Night",
    description: "Opis",
    description_placeholder: "Pozadina događaja, posebna pravila ili bilješke o glavnoj borbi...",
    venue: "Mjesto održavanja",
    venue_placeholder: "npr. Salem Indoor Stadium",
    country: "Država",
    city: "Grad",
    select_country_first: "Najprije odaberi državu",
    loading_cities: "Učitavanje gradova...",
    search_city: "Pretraži grad...",
    clear_city: "Očisti grad",
    no_cities_found: "Nema pronađenih gradova",
    location: "Lokacija",
    location_placeholder: "npr. Salem, Tamil Nadu",

    start_date: "Datum početka",
    end_date: "Datum završetka",
    start_date_time: "Datum i vrijeme početka",
    end_date_time: "Datum i vrijeme završetka",
    event: "Događaj",
    select_combat_sport: "Odaberi borilački sport",
    select_weight_class: "Odaberi težinsku kategoriju",

    event_name_required: "Naziv događaja je obavezan",
    venue_required: "Mjesto održavanja je obavezno",
    country_required: "Država je obavezna",
    city_required: "Grad je obavezan",
    location_required: "Lokacija je obavezna",
    start_date_required: "Datum početka je obavezan",
    start_date_past: "Datum početka ne može biti u prošlosti",
    start_date_time_required: "Datum i vrijeme početka su obavezni",
    start_date_time_past: "Datum i vrijeme početka ne mogu biti u prošlosti",
    end_date_time_required: "Datum i vrijeme završetka su obavezni",
    end_date_time_past: "Datum i vrijeme završetka ne mogu biti u prošlosti",
    end_date_after_start_date: "Datum i vrijeme završetka moraju biti nakon ili jednaki početku",

    draft: "Nacrt",
    published: "Objavljeno",
    upcoming: "Nadolazeće",
    live: "Uživo",
    completed: "Dovršeno",
    cancelled: "Otkazano",

    event_status: {
    DRAFT: "Nacrt",
    PUBLISHED: "Objavljeno",
    UPCOMING: "Nadolazeće",
    LIVE: "Uživo",
    COMPLETED: "Dovršeno",
    CANCELLED: "Otkazano",
  },

    matchup_status: {
      DRAFT: "Nacrt",
      OPPORTUNITY_POSTED: "Prilika objavljena",
      RED_ACCEPTED: "Crveni kut prihvatio",
      BLUE_ACCEPTED: "Plavi kut prihvatio",
      BOTH_ACCEPTED: "Oba kuta prihvatila",
      CONFIRMED: "Potvrđeno",
      CANCELLED: "Otkazano",
    },

    profile_type: {
      FIGHTER: "Borac",
      MANAGER: "Menadžer",
      ORGANIZATION: "Organizacija",
    },

    opportunity_posted: "Prilika objavljena",
    red_accepted: "Crveni kut prihvatio",
    blue_accepted: "Plavi kut prihvatio",
    both_accepted: "Oba kuta prihvatila",
    confirmed: "Potvrđeno",
    mma: "MMA",

    cancel: "Odustani",
    save: "Spremi",
    edit: "Uredi",
    delete: "Izbriši",
    confirm: "Potvrdi",
    update: "Ažuriraj",
    clear: "Očisti",

    edit_event: "Uredi događaj",
    create_event: "Stvori događaj",
    save_changes: "Spremi promjene",
    edit_event_subtitle: "Ažuriraj detalje borilačkog događaja",
    create_event_subtitle: "Zakaži i najavi novi borilački događaj",

    confirm_delete_title: "Potvrda brisanja",
    confirm_delete_message: "Jesi li siguran da želiš izbrisati ovaj događaj? Ova radnja se ne može poništiti.",
    confirm_update_title: "Potvrda ažuriranja",
    confirm_update_message: "Jesi li siguran da želiš ažurirati ovaj događaj?",
    confirm_status_change_title: "Potvrda promjene statusa",
    confirm_status_change_message: "Jesi li siguran da želiš promijeniti status događaja u {{status}}?",

    event_deleted_successfully: "Događaj je uspješno izbrisan",
    event_updated_successfully: "Događaj je uspješno ažuriran",
    event_created_successfully: "Događaj je uspješno stvoren",
    status_updated_successfully: "Status je uspješno ažuriran",
    status_update_failed: "Ažuriranje statusa nije uspjelo. Pokušaj ponovno.",
    failed_to_delete_event: "Brisanje događaja nije uspjelo",
    failed_to_update_event: "Ažuriranje događaja nije uspjelo",
    failed_to_load_event_details: "Učitavanje detalja događaja nije uspjelo",
    failed_to_save_event: "Spremanje događaja nije uspjelo. Pokušaj ponovno.",
    event_not_found: "Događaj nije pronađen ili trenutno nije dostupan.",
    event_load_failed: "Nije moguće učitati detalje događaja. Pokušaj ponovno.",
    loading_event_details: "Učitavanje detalja događaja...",
    failed_to_load_event: "Učitavanje događaja nije uspjelo",
    back_to_events: "Natrag na događaje",

    add_matchup_subtitle: "Konfiguriraj status naslova i potrebne borce",
    bout_order: "Redoslijed borbe",
    championship_title_fight: "Prvenstvo / borba za naslov",
    select_red_corner_fighter: "Odaberi borca crvenog kuta",
    select_blue_corner_fighter: "Odaberi borca plavog kuta",
    red_corner_fighter_required: "Borac crvenog kuta je obavezan.",
    blue_corner_fighter_required: "Borac plavog kuta je obavezan.",
    same_fighter_error: "Borci crvenog i plavog kuta ne mogu biti ista osoba",
    matchup_created_successfully: "Par je uspješno dodan",
    failed_to_create_matchup: "Dodavanje para nije uspjelo",
    edit_matchup: "Uredi par",
    edit_matchup_subtitle: "Ažuriraj status naslova ili borce",
    matchup_updated_successfully: "Par je uspješno ažuriran",
    failed_to_update_matchup: "Ažuriranje para nije uspjelo",
    matchup_deleted_successfully: "Par je uspješno izbrisan",
    failed_to_delete_matchup: "Brisanje para nije uspjelo",
    confirm_delete_matchup_title: "Izbriši borbu",
    confirm_delete_matchup_message: "Jesi li siguran da želiš izbrisati ovaj par? Ova radnja se ne može poništiti.",
    delete_matchup: "Izbriši par",
    loading_fighters: "Učitavanje boraca...",
    no_fighter_selected: "Nitko / nije određeno",
    failed_to_load_fighters: "Učitavanje boraca nije uspjelo",
    fighter_has_deal_locked: "Ovaj borac ima dogovor i ne može se promijeniti.",
    fighter_not_selected: "Borac nije odabran",
    fighter_number: "Borac #{{id}}",
    no_nickname: "Nema nadimka",
    nationality: "Nacionalnost",
    weight_class: "Težinska kategorija",
    discipline: "Disciplina",
    stance: "Stav",
    title_holder: "Nositelj naslova",
    select_fighter_above: "Odaberi borca iznad",
    failed_to_load_templates: "Učitavanje predložaka nije uspjelo",
    choose_template: "Odaberi predložak",
    select_template_to_preview: "Odaberi predložak za pregled",
    template_available: "{{count}} predložak dostupan",
    templates_available: "{{count}} predložaka dostupno",
    no_templates_available: "Nema dostupnih predložaka",
    steps_count: "{{count}} koraka",
    add_account: "Dodaj račun",
account_verification_pending: "Verifikacija računa na čekanju",
share_event: "Podijeli događaj",
download_matchup_list_pdf_tooltip: "Preuzmite cijeli popis mečeva za ovaj događaj kao PDF",
invite_fighters: "Pozovi borce",
invite_fighters_help: "Odaberi među Hoowlr borcima",
invite_by_email: "Pozovi e-poštom",
invite_by_email_help: "Pošalji putem adrese e-pošte",
select_hoowlr_fighters: "Odaberi Hoowlr borce",
select_hoowlr_fighters_help: "Odaberi osobe s popisa.",
selected: "odabrano",
selected_fighter: "Odabrani borac",
remove_selected_fighter: "Ukloni odabranog borca",
fighters_found: "{{count}} boraca",
page: "Stranica",
no_fighters_found: "Nema pronađenih boraca",
try_different_fighter_search: "Pokušaj s drugim imenom.",
fighters_not_available: "Trenutačno nema dostupnih boraca.",
search_fighters_to_share: "Pretraži borce po imenu",
hoowlr_fighter: "Hoowlr borac",
previous: "Prethodno",
next: "Sljedeće",
share_by_email: "Podijeli e-poštom",
share_event_email_single_help: "Dodaj jednu adresu e-pošte odjednom. Svaki primatelj prikazat će se zasebno ispod.",
added: "dodano",
enter_email_address: "Unesi jednu adresu e-pošte",
add_email: "Dodaj e-poštu",
share_event_email_enter_hint: "Pritisni Enter ili klikni Dodaj e-poštu. Adrese odvojene zarezima nisu potrebne.",
email_recipient: "Primatelj e-pošte",
remove_email_recipient: "Ukloni primatelja e-pošte",
no_email_recipients_added: "Još nema dodanih primatelja e-pošte.",
message: "Poruka",
share_event_message_placeholder: "Dodaj poruku (nije obavezno)",
attachments: "Privici",
add_file: "Dodaj datoteku",
no_attachments_added: "Još nema priloženih datoteka.",
remove_attachment: "Ukloni privitak",
attachment_too_large: "{{fileName}} je prevelika datoteka. Maksimalna veličina je 25 MB.",
attachment_upload_failed: "Prijenos privitaka nije uspio",
event_shared_successfully: "Događaj je uspješno podijeljen",
failed_to_share_event: "Dijeljenje događaja nije uspjelo",
share_event_invalid_email: "Neispravna e-pošta: {{email}}",
share_event_email_already_added: "Ova adresa e-pošte već je dodana.",
share_event_recipient_required: "Odaberi barem jednog Hoowlr borca ili dodaj adresu e-pošte.",
uploading: "Prijenos...",
share: "Podijeli",

    view_share_history: "Prikaži povijest dijeljenja",
    share_history: "Povijest dijeljenja",
    share_history_loading: "Učitavanje povijesti dijeljenja...",
    share_history_empty: "Još nema povijesti dijeljenja",
    share_history_empty_help: "Dijeljenja ovog događaja prikazat će se ovdje.",
    failed_to_load_share_history: "Učitavanje povijesti dijeljenja nije uspjelo",
    recipients: "Primatelji",
    download: "Preuzmi",
  },
};